'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: fixed;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  background-color: rgba(255,255,255,0.8);\n  z-index: 9999;\n'], ['\n  position: fixed;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  background-color: rgba(255,255,255,0.8);\n  z-index: 9999;\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n'], ['\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _View = require('../../atoms/View');
var _View2 = _interopRequireDefault(_View);
var _LoadingIcon = require('../../atoms/LoadingIcon');
var _LoadingIcon2 = _interopRequireDefault(_LoadingIcon);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Content = (0, _styledComponents2.default)(_View2.default)(_templateObject);
var LoadingWrapper = (0, _styledComponents2.default)(_View2.default)(_templateObject2);
var LoadingBackdrop = function LoadingBackdrop() {
  return _react2.default.createElement(Content, null, _react2.default.createElement(LoadingWrapper, null, _react2.default.createElement(_LoadingIcon2.default, {
    src: 'https://static.olx.com.br/accounts/loading.gif'
  })));
};
exports.default = LoadingBackdrop;